import React, { useEffect } from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const PresidentVisitLuapulaExpo = () => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}
            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Indo Zambia Bank Engages President at Luapula Investment Expo 2026</h1>

                    <p className="pb-3">We were honoured to welcome His Excellency, the President of the Republic of Zambia, at the Luapula Investment Expo 2026. The President was accompanied by Mansa Mayor, His Worship Njikho Musuku, Minister of Tourism, Hon. Rodney Sikumba MP and Luapula Province Minister, Hon. Eng. Nason Musonda MP, making the visit even more memorable.</p>

                    <p className="pb-3">As a proud sponsor of this year's Luapula Investment Expo, we were delighted to have engaged the President and share key milestones of the Bank's journey, as well as the impactful products and solutions we are rolling out to support agriculture, tourism, enterprise, and community growth across Luapula Province and the country at large.</p>

                    <p className="pb-3"><b><em>#IndoZambiaBank #LuapulaInvestmentExpo #LuapulaProvince #Agriculture #Tourism #Enterprise #CommunityGrowth</em></b></p>

                    <h2 className="pt-5 pb-4 text-left">Gallery</h2>
                    <Slider {...settings}>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0888.JPG" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0886.JPG" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0879.JPG" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0883.JPG" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0887.JPG" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0882.JPG" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0880.JPG" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                    </Slider>
                </div>
            </section>

            <CustomerCare />
            <OurStores />
        </>
    );
};

export default PresidentVisitLuapulaExpo;
